import { PropsWithChildren } from "react";

import classes from "./DashboardGrid.module.css";

type Span = 3 | 4 | 6 | 8 | 12;

type GridProps = PropsWithChildren;

export const DashboardGrid = ({ children }: GridProps) => {
  return <div className={classes.grid}>{children}</div>;
};

type CellProps = PropsWithChildren<{
  span: Span;
  /** Starting column, used when a cell should sit under a wider neighbor. */
  column?: number;
}>;

export const DashboardCell = ({ span, column, children }: CellProps) => {
  return (
    <div
      className={classes.cell}
      data-span={span}
      data-column={column}
    >
      {children}
    </div>
  );
};
